import { addDays } from "./addDays";
import type { MatchFilters } from "./matchFiltersSchema";
import { parseIsoDay } from "./parseIsoDay";
import type { PeriodPreset } from "./PERIOD_PRESETS";

// Период — дни по местному времени, оба края включительно.
export type DayRange = { from: Date; to: Date };

const presetRange = (preset: PeriodPreset, today: Date): DayRange => {
  switch (preset) {
    case "today":
      return { from: today, to: today };
    case "yesterday":
      return { from: addDays(today, -1), to: addDays(today, -1) };
    case "last_7_days":
      return { from: addDays(today, -6), to: today };
    case "last_14_days":
      return { from: addDays(today, -13), to: today };
    case "last_30_days":
      return { from: addDays(today, -29), to: today };
    case "this_month":
      return { from: new Date(today.getFullYear(), today.getMonth(), 1), to: today };
    case "last_month":
      return {
        from: new Date(today.getFullYear(), today.getMonth() - 1, 1),
        to: new Date(today.getFullYear(), today.getMonth(), 0),
      };
  }
};

// Период фильтра на сегодня (`now`). Свой период (`from`, `to`) важнее готового;
// перепутанные края меняются местами. Фильтра по дате нет — `null`.
export const periodRange = (
  { period, from, to }: Pick<MatchFilters, "period" | "from" | "to">,
  now: Date,
): DayRange | null => {
  const start = from === undefined ? null : parseIsoDay(from);
  if (start !== null) {
    const end = (to === undefined ? null : parseIsoDay(to)) ?? start;
    return start <= end ? { from: start, to: end } : { from: end, to: start };
  }
  return period === undefined ? null : presetRange(period, addDays(now, 0));
};
